/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from 'react';
import WalletLottie from "../Lottie/wallet.json";
import Lottie from "lottie-react";
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { FaWallet } from 'react-icons/fa';
import { showToast } from '../../showTost';
import { LuWallet } from "react-icons/lu";
import Payment from '../../Payment/Payment';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import { continueAfterGateway } from "../../utils/paymentResult";
const Wallet = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ApiBaseUrl, paymentStatus, setPaymentStatus, transactionid } = useContext(MyContext);

  const [mywallet, setMyWallet] = useState();
  const [history, setHistory] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [isPaymentShow, setIsPaymentShow] = useState(false);
  const [input, setInput] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);

  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";
  const Userid = secureLocalStorage.getItem("Userid");

  useEffect(() => {
    if (!Userid) {
      setLoading(false);
      return;
    }
    HandlefetchData(1);
  }, [Userid]);

  const HandlefetchData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/wallet_transaction_list`, { id: Userid, page })
        .then((res) => {
          // console.log("wallet_transaction_list", res);
          if (res.data.ResponseCode === 200) {

            const { tot_balance, wallet_list } = res.data;

            if (wallet_list.length === 0) {
              NoMoreDataRef.current = false;
            }

            if (page === 1) {
              setHistory(wallet_list);
            } else {
              setHistory(prev => [...prev, ...wallet_list]);
            }

            setLoading(false);
            setMyWallet(tot_balance);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
        hasReachedBottom.current = true;
        setPage(prevPage => prevPage + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, []);

  useEffect(() => {
    if (page === 1 || !NoMoreDataRef.current) return;
    HandlefetchData(page);
  }, [page])

  const HandleContinue = () => {
    if (!input || Number(input) <= 0) {
      showToast({ title: t("Please Enter Amount"), id: "error" });
      return;
    }

    sessionStorage.setItem("page", "6");
    sessionStorage.setItem("PaymentData", JSON.stringify({
      amount: input,
      customer_id: Userid,
    }));
    setIsPaymentShow(true);
  };

  useEffect(() => {
    if (!paymentStatus) return;
    setIsPaymentShow(false);
    if (paymentStatus === "PaymentDone") {
      continueAfterGateway(navigate, { success: true, transactionId: transactionid || "" });
    } else if (paymentStatus === "PaymentFaild") {
      continueAfterGateway(navigate, { success: false, cancelled: true, transactionId: "0" });
      setIsShow(false);
    }
    setPaymentStatus("");
  }, [paymentStatus, navigate, transactionid, setPaymentStatus]);

  return (
    <div>
      {false ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
        : <div className="">

          <div className="d-flex flex-wrap justify-between border-[2px] border-[#8080803b] px-[40px] py-[15px] rounded-[20px]">
            <div className="d-flex gap-[20px]">
              <Lottie
                className="w-[60px]"
                animationData={WalletLottie}
                loop={true}
              />
              <div className="">
                <span className='text-gray-500 font-[500] text-[16px]'>{t("TOTAL WALLET BALANCE")}</span>
                <h1 className='font-[500] text-[18px]'>{currency ? currency : "$"} {mywallet}</h1>
              </div>
            </div>
            <button onClick={() => setIsShow(true)} className='bg-[#0d9488] text-white font-[500] min-w-[150px] py-[8px] rounded-[50px]'>{t("Top Up")}</button>
          </div>

          <div className="mt-[15px]">
            <h1 className='font-[500] text-[18px]'>{t("Transaction History")}</h1>
            {history.length >= 1
              ? history.map((item, index) => {
                const Credit = item.status === "1" || item.status === "3" || item.status === "5" || item.status === "7";
                return <div key={index} className="border-[1px] border-[#8080803b] px-[20px] py-[15px] rounded-[15px] mt-[5px]">
                  <div className="flex items-center gap-[10px] justify-between">
                    <div className="flex items-center gap-[10px]">
                      <div className={`${Credit ? "bg-green-100" : "bg-red-100"} p-[10px] rounded-[100%]`}>
                        <FaWallet className={`${Credit ? "text-green-500" : "text-red-500"} text-[20px]`} />
                      </div>
                      <div className="leading-[20px]">
                        <h1 className='font-[500] text-[17px]'>{item.date}</h1>
                        <span className={`${Credit ? "text-green-500" : "text-red-500"} font-[500] text-[14px]`}>{Credit ? "Credit" : "Debit"}</span>
                      </div>
                    </div>
                    <h1 className={`${Credit ? "text-green-500" : "text-red-500"} font-[500] text-[17px]`}>{Credit ? "+" : "-"} {currency}{item.amount}.0</h1>
                  </div>
                </div>
              })
              : <div className='h-[400px] flex items-center justify-center'>
                <h1 className='font-[500] text-gray-500 text-[18px]'>{t("Go & Add your Amount")}</h1>
              </div>}
          </div>
        </div>}

      {isShow && <div onClick={() => setIsShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box">
          <h1 className='font-[500] text-[17px] text-[#0d9488]'>{("Add Wallet Amount")}</h1>
          <div className="flex items-center gap-[5px] focus-within:border-[#0d9488] mt-[5px] border-[2px] border-[#8080803b] py-[8px] px-[15px] rounded-[10px]">
            <LuWallet className='text-[23px] text-gray-500' />
            <input onChange={(e) => setInput(e.target.value)} type="number" placeholder={t('Enter Amount')} value={input || ""} disabled={isPaymentShow} className='w-[100%] bg-transparent outline-none px-[10px] font-[500]' />
          </div>
          {isPaymentShow ? (
            <Payment
              Amount={Number(input)}
              Data={{ amount: Number(input), customer_id: Userid }}
            />
          ) : (
            <button onClick={HandleContinue} className='payment-btn mt-[5px]'>{t("Continue")}</button>
          )}
        </div>
      </div>}

    </div>
  )
}

export default Wallet
/* jshint ignore:end */